import React from 'react'
import Link from 'redux-first-router-link'
import SanitizedHTML from 'shared/components/ui/SanitizedHTML'
import { Divider } from 'shared/ui'

const ResponseWithDocuments = ({ response }) => {
  const { answer, suggested_docs: suggestedDocs } = response
  return (
    <div>
      <SanitizedHTML className="body" html={answer} />
      <Divider />
      <div className="grui mt-5">Suggested KB articles:</div>
      {suggestedDocs.map(doc => (
        <div key={doc.id}>
          <Link to={doc.metadata.url} target="_blank">
            {doc.metadata.title}
          </Link>
        </div>
      ))}
    </div>
  )
}

export default ResponseWithDocuments
